import type { CardOrientation, typeCard } from '@susu/custom-made/components/card/card';
import { Card, CardInfoIconType, CardSize } from '@susu/custom-made/components/card/card';
import { ThemeContext } from '@susu/custom-made/providers';
import { fabricThumbnailDefaultPath, imageDefinition } from '@susu/custom-made/utils/imageDefinition';
import { imageUrlBuilder } from '@susu/custom-made/utils/imageUrlProvider/imageUrlProvider';
import type { Fabric, FabricGroup, typeFabricList } from '@susu/custom-made/utils/interfaces';
import { calculateFabricPrice } from '@susu/custom-made/utils/utils';
import { useContext } from 'react';

import type { cardItemsType } from './cardList';

export default function CardListFabric({
  cardItems,
  cardSubItems,
  selectedItemId,
  cardOrientation,
  isGroup,
  cardClick = () => {},
  infoIconClick,
}: Readonly<{
  cardItems: cardItemsType;
  cardSubItems?: (string | number)[];
  selectedItemId?: number | null;
  cardOrientation?: CardOrientation;
  isGroup?: boolean;
  cardClick?: (card: typeCard) => void;
  infoIconClick?: (card: typeCard) => void;
}>) {
  const { state } = useContext(ThemeContext);

  return (
    <>
      {isGroup &&
        cardItems &&
        (cardItems as FabricGroup[]).map((cardItem: FabricGroup, index: number) => {
          const item = cardItem;
          const itemImages = item.images.map(imageName => {
            const calculatedImgUrl = imageUrlBuilder({
              imageUrls: [`${fabricThumbnailDefaultPath}${imageName}`],
              imageDefinition: imageDefinition.thumbnail,
            });

            return calculatedImgUrl.src;
          });
          if (item) {
            return (
              <Card
                key={index}
                card={item}
                cardImages={itemImages}
                cardText={item.name}
                isSelected={selectedItemId != null ? selectedItemId === item.id : false}
                tabIndex={index + 1}
                cardClick={cardClick}
                cardItemAmount={item.fabrics.length}
                infoIconClick={infoIconClick}
                showInfoIcon={false}
                hideMobileInfoText={false}
                cardSize={CardSize.Medium}
                isParent={true}
                cardOrientation={cardOrientation}
              />
            );
          }
        })}

      {!isGroup &&
        cardSubItems &&
        (cardSubItems as string[]).map((cardSubItem: string, index: number) => {
          const item: Fabric = (cardItems as typeFabricList)[cardSubItem];
          const calculatedImgUrl = imageUrlBuilder({
            imageUrls: [`${fabricThumbnailDefaultPath}${item.imageName}`],
            imageDefinition: imageDefinition.thumbnail,
          });

          if (item && state.product) {
            return (
              <Card
                key={index}
                card={item}
                cardImages={[calculatedImgUrl.src]}
                cardText={item.name}
                cardSubText={item.prices.symbol + calculateFabricPrice(state.product, item.prices.configurationTypes)}
                isSelected={selectedItemId ? selectedItemId === item.id : false}
                tabIndex={index + 1}
                cardClick={cardClick}
                infoIconClick={infoIconClick}
                showInfoIcon={true}
                hideMobileInfoText={true}
                cardSize={CardSize.Small}
                cardInfoIconType={CardInfoIconType.Dark}
                isParent={false}
                cardOrientation={cardOrientation}
              />
            );
          }
        })}
    </>
  );
}
